import { useTranslations } from "hooks"

export const QuizProgress = ({stepLeft, total, onStart}: QuizProgressType): JSX.Element => {
    const v = stepLeft ? (100 - (stepLeft * 100) / total) : 100
    const isFinished = stepLeft > 0 && stepLeft <= total ? false : true
    const [START, FINISH, QUESTION, TIME] = useTranslations(i18n)
    const currentStep = total - stepLeft

    const scaleRender = (num: number):Array<JSX.Element> => {
        let r: Array<JSX.Element> = [<span 
            key={0} 
            style={{top: `0%`}} 
            className={`qprogress-scale highlight`}></span>];
        for (let index = 1; index <= num; index++) {
            const g = (index * 100) / total
            r = [...r , <span 
                    key={index} 
                    style={{top: `${g}%`}} 
                    className={`qprogress-scale ${g <= v ? 'highlight' :'' }`}></span>]
        }
        return r
    }

    const getTimeLeft = () => {
    const timeQuestion = process.env.REACT_APP_TIME_QUESTION ? parseInt(process.env.REACT_APP_TIME_QUESTION) : 15
    const time = (stepLeft) * timeQuestion
        const minutes = Math.floor(time  / 60);
        const seconds = time - minutes * 60;
        return minutes ? `${minutes}${seconds ? `:${seconds}` : ''} min` : `${seconds} sec` 
    }
    return(
        <>
            <div className="qprogress" style={{height: `${total * 50}px`}}>
                <div className="qprogress-wrap">
                    {scaleRender(total)}
                    <span className={`qprogress-content ${ v >= 100 && 'qprogress-content-full'}`} style={{height: `${v > 100 ? '100' : v == 0 ? '1' : v}%`}}></span>
                </div>
                <div className="qprogress-label">
                    <button onClick={() => onStart?.()} className="qprogress-label-txt" style={{top: '0'}}>{START}</button>
                    {(!isFinished && currentStep ) 
                        ? <p className="qprogress-label-txt" style={{top: `calc(${v}% - 20px)`}}>{QUESTION} {currentStep}</p>
                        : ''}
                    <p className="qprogress-label-txt qprogress-final" style={{top: 'calc(100% - 20px)'}}>{FINISH}</p>
                </div>
            </div>
            { !isFinished  && <p className="qprogress-time">
                {TIME}
                <br/><strong>{getTimeLeft()}</strong></p>}
        </>
    )
}

type QuizProgressType = {
    stepLeft: number
    total: number
    onStart?: () => void
}

const i18n = [
    `MedicalDevice.Progress.Start.txt`,
    `MedicalDevice.Progress.Finish.txt`,
    `MedicalDevice.Progress.Question.txt`,
    `MedicalDevice.Progress.Time.txt`
]